import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import placeholderImage from "../images/Placeholder.png";
import { API_BASE_URL } from '../config';

function LogIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggledPassword, setToggledPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function checkStatus() {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/auth/verify-token`, { withCredentials: true })
            if (response.status === 200) {
              navigate('/account');
          }
          } catch (error) {
           
        }
    }
    checkStatus();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      if (!email.includes("@")) throw new Error("Invalid email. Please try again.")
      
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { email, password }, { withCredentials: true });

      if (response.status === 200) {
        navigate("/account"); // or wherever you want to redirect
      }
    } catch (error) {
      setErrorMsg(error.response?.data?.message || error.message != "Request failed with status code 404" ? `${error.response?.data?.message} Please try again.` : "Incorrect credential(s). Please try again."|| "Incorrect credential(s). Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section style={{ margin: "3rem 5rem" }}>
      <h1 className="centered-subtitle">Log-In</h1>
      <section className="log-in-container">

        <form className="log-in-form" onSubmit={handleSubmit}>
        {errorMsg && <div className="log-in-error">* {errorMsg}</div>}

            <label>Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />

            <label>Password</label>
            <div>
            <input
              type={toggledPassword ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button className="log-in-reveal-button" type="button" onClick={()=>{setToggledPassword(!toggledPassword)}}><i className={`bi ${toggledPassword ? "bi-eye-slash" : "bi-eye"}`}></i></button>
</div>
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
          <Link to="/forgot-password">Forgot Password?</Link>
          <Link to="/sign-up">Sign Up</Link>
        </form>

        
        
      </section>

    </section>
  );
}

export default LogIn;